import { Input } from "@mantine/core";
import React from "react";

import styles from "./UserForm.module.scss";

export const LayoutContainer: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...rest }) => (
  <div className={`${styles.layoutContainer} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const Section: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...rest
}) => (
  <div className={`${styles.section} ${className ?? ""}`} {...rest}>
    {children}
  </div>
);

export const InputStyledWrapper: React.FC<
  React.ComponentProps<typeof Input.Wrapper>
> = props => <Input.Wrapper className={styles.inputStyledWrapper} {...props} />;
